import {
  DATED,
  DAY,
  SELECT_DATED_PLAN,
  SELECT_TEMPLATE,
  TEMPLATE,
} from "../../../consts/strings";
import { DATED_PLAN, MENU_ITEM } from "../../../consts/sentryIds";
import { MenuItem, Select } from "@mui/material";
import {
  findProfile,
  formatDatedPlanName,
  formatTemplateName,
} from "../../../utils/plans";

import { DayChips } from "../../DayChips/DayChips";
import { Text } from "../../Base";
import { View } from "../../View";
import { getMatrixProfiles } from "../../../reducers/matrixProfile/selectors";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  text: {
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "4px",
    marginBottom: "10px",
  },
  section: {
    marginTop: "20px",
  },
});

export const SelectPlanModalContent = ({ onPlanSelected, selectedPlan }) => {
  const { dayProfiles, datedProfiles, templates } =
    useSelector(getMatrixProfiles);
  const styles = useStyles();

  return (
    <View>
      <View className={styles.section}>
        <Text className={styles.text}>Available Daily Plans:</Text>
        <DayChips
          disableDaysNotInDepot
          selected={selectedPlan?.type === DAY && selectedPlan.value}
          onDaySelected={(value) => {
            onPlanSelected(value);
          }}
        />
      </View>
      <View className={styles.section}>
        <Text className={styles.text}>Available Dated Plans:</Text>
        <Select
          sentryId={DATED_PLAN}
          variant={"outlined"}
          fullWidth
          displayEmpty
          disabled={!datedProfiles || !datedProfiles.length}
          renderValue={(value) =>
            !value
              ? SELECT_DATED_PLAN
              : formatDatedPlanName(
                  findProfile({
                    selectedProfile: { type: DATED, value },
                    dayProfiles,
                    datedProfiles,
                    templates,
                  })
                )
          }
          value={selectedPlan?.type === DATED ? selectedPlan.value : ""}
          onChange={(e) => {
            onPlanSelected({ type: DATED, value: e.target.value });
          }}
        >
          {Array.isArray(datedProfiles) &&
            datedProfiles.map((plan, index) => (
              <MenuItem
                key={index}
                value={plan.templateId}
                sentryId={`${DATED_PLAN}__${MENU_ITEM}`}
              >
                {formatDatedPlanName(plan)}
              </MenuItem>
            ))}
        </Select>
      </View>
      <View className={styles.section}>
        <Text className={styles.text}>Available Template Plans:</Text>
        <Select
          sentryId={TEMPLATE}
          variant={"outlined"}
          fullWidth
          disabled={!templates || !templates.length}
          displayEmpty
          renderValue={(value) =>
            !value
              ? SELECT_TEMPLATE
              : formatTemplateName(
                  findProfile({
                    selectedProfile: { type: TEMPLATE, value },
                    dayProfiles,
                    datedProfiles,
                    templates,
                  })
                )
          }
          value={selectedPlan?.type === TEMPLATE ? selectedPlan.value : ""}
          onChange={(e) => {
            onPlanSelected({ type: TEMPLATE, value: e.target.value });
          }}
        >
          {Array.isArray(templates) &&
            templates.map((plan, index) => (
              <MenuItem
                key={index}
                value={plan.templateId}
                sentryId={`${TEMPLATE}__${MENU_ITEM}`}
              >
                {formatTemplateName(plan)}
              </MenuItem>
            ))}
        </Select>
      </View>
    </View>
  );
};
